import React from 'react';

const SubMenu = () => {

    return (
        <div className="section platter bg_image_8">
            <div className="container">
                <div className="platter_box">
                    <div className="platter_title">
                        <h4>Special Sea Food</h4>
                        <h4>Platter</h4>
                    </div>
                    <div className="platter_box_item">
                        <h6>Lobster Combo</h6>
                        <p>Lorem ipsum dolor sit amet consecturer duis</p>
                    </div>
                    <div className="platter_box_item">
                        <h6>Grill Sea Food Joint</h6>
                        <p>Lorem ipsum dolor sit amet consecturer duis</p>
                    </div>
                    <div className="platter_box_item">
                        <h6>Sea Food Platter</h6>
                        <p>Lorem ipsum dolor sit amet consecturer duis</p>
                    </div>
                    <div className="platter_box_item">
                        <h6>Sea Food Buffet</h6>
                        <p>Lorem ipsum dolor sit amet consecturer duis</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubMenu;